import { Component, Input } from '@angular/core';

@Component({
  selector: 'split-report-message-year-month',
  templateUrl: './split-report-message-year-month.component.html',
  styleUrls: ['./split-report-message-year-month.component.scss']
})
export class SplitReportMessageYearMonthComponent {
  @Input() year: any = new Date().getFullYear();
  @Input() percentage: number = 0;
  @Input() month: any = '';
  @Input() label: string = '';
  @Input() width: string = '';
  @Input() columns: Array<{valor: any,descricao: any}> = [];
  @Input() class: string = '';
  @Input() expense: boolean = false;

  currentClass='';

  showPercentage: boolean = false;

  switchPercentage() {
    this.showPercentage = !this.showPercentage;
    if (this.showPercentage) {
      this.currentClass = this.class;
      //this.expense ? this.class = 'expense-card' : this.class = 'green-card';
    } else {
      this.class = this.currentClass;
    }
  }
}
